import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import CourseCard from '../CourseCard/CourseCard'
import { Empty } from 'antd'
import MyCourseCard from '../MyCourseCard/MyCourseCard'

interface IMyCoursesList {
  courses: ICourseOrder[]
  onFavoriteChange: (order: ICourseOrder) => void
}

const MyCoursesList: FC<IMyCoursesList> = ({ courses, onFavoriteChange }) => {
  if (courses?.length < 1) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={'Ничего не найдено'}
      />
    )
  }

  return (
    <div className={cn.wrapper}>
      {courses?.map((course) => {
        return (
          <MyCourseCard
            order={course}
            key={course.id}
            onAddToFavorite={onFavoriteChange}
          />
        )
      })}
    </div>
  )
}

export default MyCoursesList
